//--------------------------------------------------------------------------------
//
// AIO Video control
//
//--------------------------------------------------------------------------------

//--------------------------------------------------------------------------------
//
// Player state
//
//--------------------------------------------------------------------------------

let currentNode = null;
let currentNodeID = null;
let currentPostID = null;

const skipAmount = 5;

//--------------------------------------------------------------------------------
//
// INIT
//
//--------------------------------------------------------------------------------

export function vdInit(app) {
    app.ports.play.subscribe(play(app));
    app.ports.playFwd.subscribe(playFwd(app));
    app.ports.playRev.subscribe(playRev(app));
    app.ports.playOff.subscribe(playOff(app));
    app.ports.playPos.subscribe(playPos(app));
}

//--------------------------------------------------------------------------------
//
// PLAY
//
//--------------------------------------------------------------------------------

// function asNodeID(purpose, id) { return "vp-" + purpose + "-" + id; }
// function postNodeID(postID) { return "post-node-" + postID; }

export function play(app)
{
    return function([ newNodeID, postID ]) {
        requestAnimationFrame(function() {
          setTimeout(function() {
            if (!newNodeID) {
                console.error("Bad player UUID");
                return;
            }

            if (currentNodeID) {
                const old = document.getElementById(currentNodeID);
                if (old) {
                    old.pause();
                }
            }

            currentNodeID = newNodeID;
            currentPostID = postID;

            const player = document.getElementById(newNodeID);
            if (!player) {
                console.error("Bad player");
                return;
            }
            currentNode = player;

            // player.onended = (event) => { // player.currentTime = 0; app.ports.playEnd.send(currentNodeID); app.ports.playEnd.send(postID);
            //     sendPlayMon(app, "end");
            // };
            //
            // player.ontimeupdate = (event) => { // let pos = (player.currentTime / player.duration)*100; app.ports.playPos.send(pos);
            //     // console.log(">>> dispatchEvent");
            //     // console.log(">>> dispatchEvent event:", event);
            //     // if (currentNode != null) {
            //     //     currentNode.dispatchEvent(new Event("aio-pos"));
            //     // }
            //     sendPlayMon(app, "pos");
            // };

            // player.onplay    = (event) => { console.log(">>> MON PLAY    <<<", event); };
            // player.onseeked  = (event) => { console.log(">>> MON SEEKED  <<<", event); };
            // player.onseeking = (event) => { console.log(">>> MON SEEKING <<<", event); };
            // player.onstalled = (event) => { console.log(">>> MON STALLED <<<", event); };
            // player.onsuspend = (event) => { console.log(">>> MON SUSPEND <<<", event); };
            // player.onwaiting = (event) => { console.log(">>> MON WAITING <<<", event); };

            player.play();
          }, 10);
        });
    }
}

// -- NOTES --
//
// ** ended         Playback has stopped because the end of the media was reached.
// ** timeupdate    The time indicated by the currentTime attribute has been updated.
// -- error         An error occurred while fetching the media data, or the type of the resource is not a supported media format.
// -- loadeddata    The first frame of the media has finished loading.
// -- loadedmetadata The metadata has been loaded.
// -- pause         Playback has been paused.
// >> play          Playback has begun.
// -- playing       Playback is ready to start after having been paused or delayed due to lack of data.
// -- progress      Fired periodically as the browser loads a resource.
// -- ratechange    The playback rate has changed.
// >> seeked        A seek operation completed.
// >> seeking       A seek operation began.
// >> stalled       The user agent is trying to fetch media data, but data is unexpectedly not forthcoming.
// >> suspend       Media data loading has been suspended.
// >> waiting       Playback has stopped because of a temporary lack of data.


export function playRev(app)
{
    return function() {
        if (currentNode) {
            currentNode.currentTime -= skipAmount;
        }
    }
}


export function playFwd(app)
{
    return function() {
        if (currentNode) {
            currentNode.currentTime += skipAmount;
        }
    }
}


export function playOff(app)
{
    return function() {
        if (currentNode) {
            currentNode.pause();
            // sendPlayMon(app, "off");
            currentNode   = null;
            currentNodeID = null;
        }
    }
}

function playPos(app)
{
    return function(pos) {
        console.log(">>> playPos pos:", pos);
        if (currentNode) {
            currentNode.currentTime = pos;
        }
    }
}

// function sendPlayMon(app, action) {
//     if (app && currentNode) {
//         app.ports.playMon.send({
//             action: action,
//             nodeID: currentNodeID,
//             postID: currentPostID,
//             pos:    (currentNode.currentTime/currentNode.duration)*100,
//             len:    currentNode.duration,
//         });
//     }
// }

//--------------------------------------------------------------------------------

